const LISTA_PRECIOS = (state, lista_precios) => {
    state.lista_precios = lista_precios;
};

const LISTA_PRECIO_SELECCIONADA = (state, lista_precio) => {
    alert('LISTA_PRECIO_SELECCIONADA')
    alert(lista_precio.nombre)
    state.lista_precio_seleccionada = lista_precio;
};

export default {
    LISTA_PRECIOS,
    LISTA_PRECIO_SELECCIONADA,
};